<template>
  <v-card>
    <v-card-title class="secondary white--text">Add Notification Template</v-card-title>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-select
            label="Group"
            :items="['General','Portals','Marketing']"
            hide-details
            v-model="item.group"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Name"
            placeholder="eg. unique-action-name"
            hide-details
            :autofocus="true"
            @change="checkName"
            v-model="item.name"
            v-on:keyup.enter="add"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Description"
            placeholder="eg. Detailed action description"
            hide-details
            v-model="item.description"
            v-on:keyup.enter="add"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions class="grey lighten-4">
      <v-spacer></v-spacer>
      <v-btn color="green" dark @click="add">Add</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "AddTemplate",
  data() {
    return {
      item: {
        group: "General",
        name: "",
        description: ""
      }
    };
  },
  computed: {},
  methods: {
    add() {
      if (!this.item.name) {
        return alert("Requires name");
      }
      if (!this.item.group) {
        return alert("Requires group");
      }
      if (this.item.name.includes(" ")) {
        return alert(
          "Please dont include spaces in the name, use description instead."
        );
      }
      this.$emit("add", this.item);
      this.$emit("close");
      this.item = {
        group: "General",
        name: "",
        description: ""
      };
    }
  }
};
</script>

<style>
</style>